import React, { useState } from 'react';

const TRUSTPILOT_URL = 'https://www.trustpilot.com/evaluate/godoorly.com';
const GOOGLE_URL     = 'https://g.page/r/CSBYlRbNPwVkEBM/review';

export const isHighRating = (rating, scale = 5) => {
  if (!rating) return false;
  if (scale === 5) return rating >= 4;
  if (scale === 10) return rating >= 9;
  return false;
};

export default function TrustpilotPrompt({ onClose, context = 'borrower' }) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  const heading = context === 'partner'
    ? 'Share your DoorlyPro experience and help more agents close deals faster.'
    : 'Your review helps more families find their path to homeownership through Doorly.';

  return (
    <div style={{
      marginTop: 16, background: 'linear-gradient(135deg, #111827 0%, #1e3a6e 100%)',
      borderRadius: 16, padding: '24px 20px', textAlign: 'center', border: '1px solid rgba(255,255,255,0.08)',
    }}>
      <div style={{ fontSize: '32px', marginBottom: '8px' }}>🌟</div>
      <div style={{ fontSize: 16, fontWeight: 800, color: '#fff', marginBottom: 6 }}>Love Doorly? Help others find us</div>
      <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)', marginBottom: 18, lineHeight: 1.6 }}>{heading}</div>

      <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: 12 }}>
        {/* Trustpilot */}
        <button onClick={() => { window.open(TRUSTPILOT_URL, '_blank'); setDismissed(true); onClose?.(); }}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '12px 20px', background: '#00b67a', color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer', fontWeight: 700, fontSize: 14, minWidth: 155 }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#fff"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
          Trustpilot
        </button>

        {/* Google */}
        <button onClick={() => { window.open(GOOGLE_URL, '_blank'); setDismissed(true); onClose?.(); }}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '12px 20px', background: '#fff', color: '#374151', border: 'none', borderRadius: 10, cursor: 'pointer', fontWeight: 700, fontSize: 14, minWidth: 155 }}>
          <svg width="14" height="14" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
          Google
        </button>
      </div>

      <button onClick={() => { setDismissed(true); onClose?.(); }}
        style={{ display: 'block', width: '100%', background: 'none', border: 'none', cursor: 'pointer', fontSize: 12, color: 'rgba(255,255,255,0.35)', fontWeight: 600 }}>
        Maybe later
      </button>
    </div>
  );
}
